import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';

import { CustomIcon } from '~components/index';
import InputLabel from '../InputLabel/InputLabel';
import '../inputs.scss';

interface Props extends CommonInputProps {
  defaultValue?: string | number;
  rows?: number;
  iconName?: IconName;
  hookOnChange?: (value: string) => void;
  onInputChange?: (value: string) => void;
}

const InputTextArea = ({
  name,
  label,
  placeholder,
  labelHelper,
  iconName,
  defaultValue,
  disabled = false,
  readOnly = false,
  required = false,
  design = 'col-12',
  hookError,
  hookOnChange = () => {},
  onInputChange = () => {},
  onFocus = () => {},
  onBlur = () => {}
}: Props) => {
  const { t } = useTranslation();
  const debouncedSetValue = debounce((value: string) => {
    hookOnChange(value);
    onInputChange(value);
  }, 200);

  return (
    <div className={`customInput customInput_textArea ${design}`}>
      {label && (
        <InputLabel
          helper={labelHelper}
          name={name}
          text={label}
          required={required}
        />
      )}
      <div
        className={`customInput_container ${
          disabled ? 'customInput_disabled' : ''
        }`}
      >
        {iconName && (
          <CustomIcon
            className="customInput_icon"
            name={iconName}
            color="var(--gray)"
          />
        )}
        <textarea
          rows={4}
          id={name}
          placeholder={placeholder && t(placeholder)}
          disabled={disabled}
          readOnly={readOnly}
          defaultValue={defaultValue}
          onChange={(e) => {
            const value = e.target.value;
            debouncedSetValue(value);
          }}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      </div>
      {hookError?.message && (
        <p className="customInput_error">{t(hookError?.message)}</p>
      )}
    </div>
  );
};

export default InputTextArea;
